import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_AUDIENCE } from "@/lib/config";
import { setAuthGetter } from "@/lib/axios";

function TokenInjector({ children }: { children: React.ReactNode }) {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  useEffect(() => {
    if (isAuthenticated) {
      setAuthGetter(() =>
        getAccessTokenSilently({
          authorizationParams: { audience: AUTH0_AUDIENCE },
        })
      );
    } else {
      setAuthGetter(null);
    }
  }, [isAuthenticated, getAccessTokenSilently]);

  return <>{children}</>;
}

function Auth0ProviderWithNavigate({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: { returnTo?: string }) => {
    navigate(appState?.returnTo || "/");
  };

  return (
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin + "/callback",
        audience: AUTH0_AUDIENCE,
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
    >
      <TokenInjector>{children}</TokenInjector>
    </Auth0Provider>
  );
}

export default Auth0ProviderWithNavigate;
